!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("prop-types"), require("react")) : "function" == typeof define && define.amd ? define([,], t) : "object" == typeof exports ? exports["trowe-layout"] = t(require("prop-types"), require("react")) : e["trowe-layout"] = t(e[void 0], e[void 0]);
}(window, function (e, t) {
  return function (e) {
    var t = {};
    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }
    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "/", r(r.s = 10);
  }([function (t, r) {
    t.exports = e;
  }, function (e, r) {
    e.exports = t;
  }, function (e, t, r) {
    e.exports = r(5);
  }, function (e, t) {
    e.exports = "data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M10.59 7.40991L6 2.82991L1.41 7.40991L0 5.99991L6 -8.7738e-05L12 5.99991L10.59 7.40991Z' fill='%2305C3DE'/%3E %3C/svg%3E";
  }, function (e, t) {
    e.exports = "data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M1.41 0.590027L6 5.17003L10.59 0.590027L12 2.00003L6 8.00003L0 2.00003L1.41 0.590027Z' fill='%23879199'/%3E %3C/svg%3E";
  }, function (e, t, r) {
    "use strict";

    t.__esModule = !0, t.flush = function () {
      var e = i.cssRules();
      return i.flush(), e;
    }, t.default = void 0;
    var n,
      o = r(1);
    var i = new ((n = r(6)) && n.__esModule ? n : {
        default: n
      }).default(),
      s = function (e) {
        var t, r;
        function n(t) {
          var r;
          return (r = e.call(this, t) || this).prevProps = {}, r;
        }
        r = e, (t = n).prototype = Object.create(r.prototype), t.prototype.constructor = t, t.__proto__ = r, n.dynamic = function (e) {
          return e.map(function (e) {
            var t = e[0],
              r = e[1];
            return i.computeId(t, r);
          }).join(" ");
        };
        var o = n.prototype;
        return o.shouldComponentUpdate = function (e) {
          return this.props.id !== e.id || String(this.props.dynamic) !== String(e.dynamic);
        }, o.componentWillUnmount = function () {
          i.remove(this.props);
        }, o.render = function () {
          return this.shouldComponentUpdate(this.prevProps) && (this.prevProps.id && i.remove(this.prevProps), i.add(this.props), this.prevProps = this.props), null;
        }, n;
      }(o.Component);
    t.default = s;
  }, function (e, t, r) {
    "use strict";

    t.__esModule = !0, t.default = void 0;
    var n = i(r(7)),
      o = i(r(8));
    function i(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    var s = function () {
      function e(e) {
        var t = void 0 === e ? {} : e,
          r = t.styleSheet,
          n = void 0 === r ? null : r,
          i = t.optimizeForSpeed,
          s = void 0 !== i && i,
          a = t.isBrowser,
          u = void 0 === a ? "undefined" != typeof window : a;
        this._sheet = n || new o.default({
          name: "styled-jsx",
          optimizeForSpeed: s
        }), this._sheet.inject(), n && "boolean" == typeof s && (this._sheet.setOptimizeForSpeed(s), this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()), this._isBrowser = u, this._fromServer = void 0, this._indices = {}, this._instancesCounts = {}, this.computeId = this.createComputeId(), this.computeSelector = this.createComputeSelector();
      }
      var t = e.prototype;
      return t.add = function (e) {
        var t = this;
        void 0 === this._optimizeForSpeed && (this._optimizeForSpeed = Array.isArray(e.children), this._sheet.setOptimizeForSpeed(this._optimizeForSpeed), this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()), this._isBrowser && !this._fromServer && (this._fromServer = this.selectFromServer(), this._instancesCounts = Object.keys(this._fromServer).reduce(function (e, t) {
          return e[t] = 0, e;
        }, {}));
        var r = this.getIdAndRules(e),
          n = r.styleId,
          o = r.rules;
        if (n in this._instancesCounts) this._instancesCounts[n] += 1;else {
          var i = o.map(function (e) {
            return t._sheet.insertRule(e);
          }).filter(function (e) {
            return -1 !== e;
          });
          this._indices[n] = i, this._instancesCounts[n] = 1;
        }
      }, t.remove = function (e) {
        var t = this,
          r = this.getIdAndRules(e).styleId;
        if (function (e, t) {
          if (!e) throw new Error("StyleSheetRegistry: " + t + ".");
        }(r in this._instancesCounts, "styleId: `" + r + "` not found"), this._instancesCounts[r] -= 1, this._instancesCounts[r] < 1) {
          var n = this._fromServer && this._fromServer[r];
          n ? (n.parentNode.removeChild(n), delete this._fromServer[r]) : (this._indices[r].forEach(function (e) {
            return t._sheet.deleteRule(e);
          }), delete this._indices[r]), delete this._instancesCounts[r];
        }
      }, t.update = function (e, t) {
        this.add(t), this.remove(e);
      }, t.flush = function () {
        this._sheet.flush(), this._sheet.inject(), this._fromServer = void 0, this._indices = {}, this._instancesCounts = {}, this.computeId = this.createComputeId(), this.computeSelector = this.createComputeSelector();
      }, t.cssRules = function () {
        var e = this,
          t = this._fromServer ? Object.keys(this._fromServer).map(function (t) {
            return [t, e._fromServer[t]];
          }) : [],
          r = this._sheet.cssRules();
        return t.concat(Object.keys(this._indices).map(function (t) {
          return [t, e._indices[t].map(function (e) {
            return r[e].cssText;
          }).join(e._optimizeForSpeed ? "" : "\n")];
        }).filter(function (e) {
          return Boolean(e[1]);
        }));
      }, t.createComputeId = function () {
        var e = {};
        return function (t, r) {
          if (!r) return "jsx-" + t;
          var o = String(r),
            i = t + o;
          return e[i] || (e[i] = "jsx-" + (0, n.default)(t + "-" + o)), e[i];
        };
      }, t.createComputeSelector = function (e) {
        void 0 === e && (e = /__jsx-style-dynamic-selector/g);
        var t = {};
        return function (r, n) {
          this._isBrowser || (n = n.replace(/\/style/gi, "\\/style"));
          var o = r + n;
          return t[o] || (t[o] = n.replace(e, r)), t[o];
        };
      }, t.getIdAndRules = function (e) {
        var t = this,
          r = e.children,
          n = e.dynamic,
          o = e.id;
        if (n) {
          var i = this.computeId(o, n);
          return {
            styleId: i,
            rules: Array.isArray(r) ? r.map(function (e) {
              return t.computeSelector(i, e);
            }) : [this.computeSelector(i, r)]
          };
        }
        return {
          styleId: this.computeId(o),
          rules: Array.isArray(r) ? r : [r]
        };
      }, t.selectFromServer = function () {
        return Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]')).reduce(function (e, t) {
          return e[t.id.slice(2)] = t, e;
        }, {});
      }, e;
    }();
    t.default = s;
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      for (var t = 5381, r = e.length; r;) t = 33 * t ^ e.charCodeAt(--r);
      return t >>> 0;
    };
  }, function (e, t, r) {
    "use strict";

    (function (e) {
      function r(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }
      t.__esModule = !0, t.default = void 0;
      var n = void 0 !== e && e.env && !0,
        o = function o(e) {
          return "[object String]" === Object.prototype.toString.call(e);
        },
        i = function () {
          function e(e) {
            var t = void 0 === e ? {} : e,
              r = t.name,
              i = void 0 === r ? "stylesheet" : r,
              a = t.optimizeForSpeed,
              u = void 0 === a ? n : a,
              c = t.isBrowser,
              l = void 0 === c ? "undefined" != typeof window : c;
            s(o(i), "`name` must be a string"), this._name = i, this._deletedRulePlaceholder = "#" + i + "-deleted-rule____{}", s("boolean" == typeof u, "`optimizeForSpeed` must be a boolean"), this._optimizeForSpeed = u, this._isBrowser = l, this._serverSheet = void 0, this._tags = [], this._injected = !1, this._rulesCount = 0;
            var d = this._isBrowser && document.querySelector('meta[property="csp-nonce"]');
            this._nonce = d ? d.getAttribute("content") : null;
          }
          var t,
            i,
            a,
            u = e.prototype;
          return u.setOptimizeForSpeed = function (e) {
            s("boolean" == typeof e, "`setOptimizeForSpeed` accepts a boolean"), s(0 === this._rulesCount, "optimizeForSpeed cannot be when rules have already been inserted"), this.flush(), this._optimizeForSpeed = e, this.inject();
          }, u.isOptimizeForSpeed = function () {
            return this._optimizeForSpeed;
          }, u.inject = function () {
            var e = this;
            if (s(!this._injected, "sheet already injected"), this._injected = !0, this._isBrowser && this._optimizeForSpeed) return this._tags[0] = this.makeStyleTag(this._name), this._optimizeForSpeed = "insertRule" in this.getSheet(), void (this._optimizeForSpeed || (n || console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode."), this.flush(), this._injected = !0));
            this._serverSheet = {
              cssRules: [],
              insertRule: function insertRule(t, r) {
                return "number" == typeof r ? e._serverSheet.cssRules[r] = {
                  cssText: t
                } : e._serverSheet.cssRules.push({
                  cssText: t
                }), r;
              },
              deleteRule: function deleteRule(t) {
                e._serverSheet.cssRules[t] = null;
              }
            };
          }, u.getSheetForTag = function (e) {
            if (e.sheet) return e.sheet;
            for (var t = 0; t < document.styleSheets.length; t++) if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
          }, u.getSheet = function () {
            return this.getSheetForTag(this._tags[this._tags.length - 1]);
          }, u.insertRule = function (e, t) {
            if (s(o(e), "`insertRule` accepts only strings"), !this._isBrowser) return "number" != typeof t && (t = this._serverSheet.cssRules.length), this._serverSheet.insertRule(e, t), this._rulesCount++;
            if (this._optimizeForSpeed) {
              var r = this.getSheet();
              "number" != typeof t && (t = r.cssRules.length);
              try {
                r.insertRule(e, t);
              } catch (t) {
                return n || console.warn("StyleSheet: illegal rule: \n\n" + e + "\n\nSee https://stackoverflow.com/q/20007992 for more info"), -1;
              }
            } else {
              var i = this._tags[t];
              this._tags.push(this.makeStyleTag(this._name, e, i));
            }
            return this._rulesCount++;
          }, u.replaceRule = function (e, t) {
            if (this._optimizeForSpeed || !this._isBrowser) {
              var r = this._isBrowser ? this.getSheet() : this._serverSheet;
              if (t.trim() || (t = this._deletedRulePlaceholder), !r.cssRules[e]) return e;
              r.deleteRule(e);
              try {
                r.insertRule(t, e);
              } catch (o) {
                n || console.warn("StyleSheet: illegal rule: \n\n" + t + "\n\nSee https://stackoverflow.com/q/20007992 for more info"), r.insertRule(this._deletedRulePlaceholder, e);
              }
            } else {
              var o = this._tags[e];
              s(o, "old rule at index `" + e + "` not found"), o.textContent = t;
            }
            return e;
          }, u.deleteRule = function (e) {
            if (this._isBrowser) {
              if (this._optimizeForSpeed) this.replaceRule(e, "");else {
                var t = this._tags[e];
                s(t, "rule at index `" + e + "` not found"), t.parentNode.removeChild(t), this._tags[e] = null;
              }
            } else this._serverSheet.deleteRule(e);
          }, u.flush = function () {
            this._injected = !1, this._rulesCount = 0, this._isBrowser ? (this._tags.forEach(function (e) {
              return e && e.parentNode.removeChild(e);
            }), this._tags = []) : this._serverSheet.cssRules = [];
          }, u.cssRules = function () {
            var e = this;
            return this._isBrowser ? this._tags.reduce(function (t, r) {
              return r ? t = t.concat(Array.prototype.map.call(e.getSheetForTag(r).cssRules, function (t) {
                return t.cssText === e._deletedRulePlaceholder ? null : t;
              })) : t.push(null), t;
            }, []) : this._serverSheet.cssRules;
          }, u.makeStyleTag = function (e, t, r) {
            t && s(o(t), "makeStyleTag acceps only strings as second parameter");
            var n = document.createElement("style");
            this._nonce && n.setAttribute("nonce", this._nonce), n.type = "text/css", n.setAttribute("data-" + e, ""), t && n.appendChild(document.createTextNode(t));
            var i = document.head || document.getElementsByTagName("head")[0];
            return r ? i.insertBefore(n, r) : i.appendChild(n), n;
          }, t = e, (i = [{
            key: "length",
            get: function get() {
              return this._rulesCount;
            }
          }]) && r(t.prototype, i), a && r(t, a), e;
        }();
      function s(e, t) {
        if (!e) throw new Error("StyleSheet: " + t + ".");
      }
      t.default = i;
    }).call(this, r(9));
  }, function (e, t) {
    var r,
      n,
      o = e.exports = {};
    function i() {
      throw new Error("setTimeout has not been defined");
    }
    function s() {
      throw new Error("clearTimeout has not been defined");
    }
    function a(e) {
      if (r === setTimeout) return setTimeout(e, 0);
      if ((r === i || !r) && setTimeout) return r = setTimeout, setTimeout(e, 0);
      try {
        return r(e, 0);
      } catch (t) {
        try {
          return r.call(null, e, 0);
        } catch (t) {
          return r.call(this, e, 0);
        }
      }
    }
    !function () {
      try {
        r = "function" == typeof setTimeout ? setTimeout : i;
      } catch (e) {
        r = i;
      }
      try {
        n = "function" == typeof clearTimeout ? clearTimeout : s;
      } catch (e) {
        n = s;
      }
    }();
    var u,
      c = [],
      l = !1,
      d = -1;
    function h() {
      l && u && (l = !1, u.length ? c = u.concat(c) : d = -1, c.length && p());
    }
    function p() {
      if (!l) {
        var e = a(h);
        l = !0;
        for (var t = c.length; t;) {
          for (u = c, c = []; ++d < t;) u && u[d].run();
          d = -1, t = c.length;
        }
        u = null, l = !1, function (e) {
          if (n === clearTimeout) return clearTimeout(e);
          if ((n === s || !n) && clearTimeout) return n = clearTimeout, clearTimeout(e);
          try {
            n(e);
          } catch (t) {
            try {
              return n.call(null, e);
            } catch (t) {
              return n.call(this, e);
            }
          }
        }(e);
      }
    }
    function f(e, t) {
      this.fun = e, this.array = t;
    }
    function m() {}
    o.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
      c.push(new f(e, t)), 1 !== c.length || l || a(p);
    }, f.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = m, o.addListener = m, o.once = m, o.off = m, o.removeListener = m, o.removeAllListeners = m, o.emit = m, o.prependListener = m, o.prependOnceListener = m, o.listeners = function (e) {
      return [];
    }, o.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, o.cwd = function () {
      return "/";
    }, o.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, o.umask = function () {
      return 0;
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t), r.d(t, "Accordion", function () {
      return N;
    });
    var n = r(2),
      o = r.n(n),
      i = r(1),
      s = r.n(i);
    function a(e) {
      return ("function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function u(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function c(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && m(e, t);
    }
    function l(e) {
      var t = f();
      return function () {
        var r,
          n = y(e);
        if (t) {
          var o = y(this).constructor;
          Reflect.construct(n, arguments, o);
        } else n.apply(this, arguments);
        return d(this, r);
      };
    }
    function d(e, t) {
      if (t && ("object" === a(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function h(e) {
      var t = "function" == typeof Map ? new Map() : void 0;
      return function (e) {
        if (null === e || (e, -1 === Function.toString.call(r).indexOf("[native code]"))) return e;
        var r;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== t) {
          if (t.has(e)) return t.get(e);
          t.set(e, n);
        }
        function n() {
          return p(e, arguments, y(this).constructor);
        }
        return n.prototype = Object.create(e.prototype, {
          constructor: {
            value: n,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), m(n, e);
      }(e);
    }
    function p(e, t, r) {
      return (f() ? Reflect.construct : function (e, t, r) {
        var n = [null];
        n.push.apply(n, t);
        var o = new (Function.bind.apply(e, n))();
        return r && m(o, r.prototype), o;
      }).apply(null, arguments);
    }
    function f() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }
    function m(e, t) {
      return (Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function y(e) {
      return (Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    Error, Error;
    var g = new WeakMap(),
      v = r(0),
      _ = r.n(v),
      x = r(3),
      b = r.n(x),
      w = r(4),
      S = r.n(w);
    var j = ["@custom-media --small-up (min-width:322px);@custom-media --small-down (max-width:320px);@custom-media --small-only (max-width:320px);@custom-media --medium-up (min-width:722px);@custom-media --medium-down (max-width:720px);@custom-media --medium-only (max-width:720px) and (min-width:321.001);@custom-media --large-up (min-width:1082px);@custom-media --large-down (max-width:1080px);@custom-media --large-only (max-width:1080px) and (min-width:721.001);@custom-media --xlarge-up (min-width:1442px);@custom-media --xlarge-down (max-width:1440px);@custom-media --xlarge-only (max-width:1440px) and (min-width:1081.001);@custom-media --xxlarge-up (min-width:1922px);@custom-media --xxlarge-down (max-width:1920px);@custom-media --xxlarge-only (max-width:1920px) and (min-width:1441.001);@custom-media --small-up-height (min-height:322px);@custom-media --small-down-height (max-height:320px);@custom-media --small-only-height (max-height:320px);@custom-media --medium-up-height (min-height:722px);@custom-media --medium-down-height (max-height:720px);@custom-media --medium-only-height (max-height:720px) and (min-height:321.001);@custom-media --large-up-height (min-height:1082px);@custom-media --large-down-height (max-height:1080px);@custom-media --large-only-height (max-height:1080px) and (min-height:721.001);@custom-media --xlarge-up-height (min-height:1442px);@custom-media --xlarge-down-height (max-height:1440px);@custom-media --xlarge-only-height (max-height:1440px) and (min-height:1081.001);@custom-media --xxlarge-up-height (min-height:1922px);@custom-media --xxlarge-down-height (max-height:1920px);@custom-media --xxlarge-only-height (max-height:1920px) and (min-height:1441.001);.jsx-4032804289:root{@lost gutter 24px;}", "button.jsx-4032804289{outline:0;border:0;background:none;padding:0;font-family:inherit;font-style:inherit;cursor:pointer;}", ".accordion-title.jsx-4032804289 img.jsx-4032804289{float:right;}", "div.accordion-section-wrapper.jsx-4032804289{padding:0;}", "button.jsx-4032804289{padding:calc(8px * 2);text-align:left;width:100%;font-weight:bold;}", ".expander-sectional.jsx-4032804289{margin:0 auto 2px auto;background-color:#ffffff;}", ".expanded.jsx-4032804289{margin-bottom:calc(8px * 2);border-top:#05c3de 4px solid;padding-bottom:8px;}", ".expanded-btn.jsx-4032804289{border-bottom:#ebebeb 1px solid;}", ".expander-subtext.jsx-4032804289{display:block;padding-top:8px;font-weight:normal;font-size:14px;}"];
    j.__hash = "4032804289";
    var O = j,
      C = function C(e) {
        var t = e.title,
          r = e.subText,
          n = e.children,
          i = e.showCaret,
          a = e.expanded,
          u = e.expandID,
          c = e.styles,
          l = e.openCaret,
          d = e.closedCaret,
          h = e.handleClick;
        return s.a.createElement("div", {
          className: "jsx-".concat(c.__hash) + " " + ((a ? "expander-sectional expanded" : "expander-sectional") || "")
        }, s.a.createElement("button", {
          type: "button",
          onClick: n ? h : void 0,
          className: "jsx-".concat(c.__hash) + " " + ((a ? "expanded-btn" : "") || "")
        }, s.a.createElement("div", {
          id: u,
          className: "jsx-".concat(c.__hash) + " accordion-title"
        }, t, i && s.a.createElement("img", {
          src: a ? l : d,
          alt: "Toggle Caret",
          className: "jsx-".concat(c.__hash)
        })), r && s.a.createElement("span", {
          className: "jsx-".concat(c.__hash) + " expander-subtext"
        }, r)), a && n, s.a.createElement(o.a, {
          id: c.__hash
        }, c));
      };
    C.defaultProps = {
      children: null,
      title: "",
      subText: "",
      showCaret: !0,
      styles: O,
      openCaret: b.a,
      closedCaret: S.a,
      expandID: ""
    }, C.propTypes = {
      openCaret: _.a.node,
      closedCaret: _.a.node,
      styles: _.a.string,
      title: _.a.node,
      subText: _.a.node,
      children: _.a.node,
      showCaret: _.a.bool,
      expandID: _.a.string
    };
    var T = C,
      R = ["sections", "oneAtATime", "title"];
    function E() {
      return (E = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      }).apply(this, arguments);
    }
    function A(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null == r) return;
        var n,
          o,
          i = [],
          s = !0,
          a = !1;
        try {
          for (r = r.call(e); !(s = (n = r.next()).done) && (i.push(n.value), !t || i.length !== t); s = !0);
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            s || null == r.return || r.return();
          } finally {
            if (a) throw o;
          }
        }
        return i;
      }(e, t) || k(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function F(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function P(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? F(Object(r), !0).forEach(function (t) {
          z(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : F(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function z(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function I(e) {
      return function (e) {
        if (Array.isArray(e)) return B(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || k(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function k(e, t) {
      if (e) {
        if ("string" == typeof e) return B(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? B(e, t) : void 0;
      }
    }
    function B(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function L(e, t) {
      if (null == e) return {};
      var r,
        n,
        o = function (e, t) {
          if (null == e) return {};
          var r,
            n,
            o = {},
            i = Object.keys(e);
          for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
          return o;
        }(e, t);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
      }
      return o;
    }
    var M = function M(e) {
      var t = e.sections,
        r = e.oneAtATime,
        n = e.title,
        a = L(e, R),
        u = n ? [].concat(I(t), [P({
          title: n
        }, a)]) : t,
        c = t.map(function (e, t) {
          return P(P({}, e), {}, {
            id: t
          });
        }).filter(function (e) {
          return e.defaultExpanded;
        }).map(function (e) {
          return e.id;
        }),
        l = A(Object(i.useState)(new Set(c)), 2),
        d = l[0],
        h = l[1];
      return s.a.createElement("div", {
        className: "jsx-".concat(O.__hash) + " accordion-section-wrapper"
      }, u.map(function (e, t) {
        return s.a.createElement(s.a.Fragment, {
          key: "".concat(e.title)
        }, s.a.createElement(T, E({
          expanded: d.has(t),
          handleClick: function handleClick() {
            return function (e) {
              if (d.has(e)) h(new Set(I(d).filter(function (t) {
                return t !== e;
              })));else {
                var t = new Set(r ? [e] : [].concat(I(d), [e]));
                h(t);
              }
            }(t);
          }
        }, e)));
      }), s.a.createElement(o.a, {
        id: O.__hash
      }, O));
    };
    M.defaultProps = {
      sections: [],
      defaultExpanded: !1,
      oneAtATime: !0
    }, M.propTypes = {
      defaultExpanded: _.a.bool,
      sections: _.a.arrayOf(_.a.shape({
        openCaret: _.a.node,
        closedCaret: _.a.node,
        styles: _.a.string,
        title: _.a.node,
        subText: _.a.node,
        children: _.a.node,
        showCaret: _.a.bool,
        expandID: _.a.string
      })),
      oneAtATime: _.a.bool
    };
    var N = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.name,
        r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : " is still an experimental feature, and it may change.",
        n = "".concat(t).concat(r);
      return g.set(e, n), e;
    }(M);
  }]);
});